import { Component, OnInit } from '@angular/core';
import { IMyOptions } from 'ng-uikit-pro-standard';
import { AuthService } from 'src/app/share/services/auth.service';
import { Location } from '@angular/common';
import { ITourDetail, TourManagementService } from '../tour-management.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPageViewModel } from 'src/app/share/pages/pages';

@Component({
  selector: 'app-tour-management-detail',
  templateUrl: './tour-management-detail.component.html',
  styleUrls: ['./tour-management-detail.component.scss']
})
export class TourManagementDetailComponent implements OnInit {

  constructor(private authService: AuthService, private location: Location, private tourManagementService: TourManagementService) { }

  vm$: Observable<any>;
  startDate: Date;
  endDate: Date;

  tmDatePickerOptions: IMyOptions = {
    todayBtnTxt: "Today",
    clearBtnTxt: "Clear",
    closeBtnTxt: "Close",
    showTodayBtn: true,
    showClearDateBtn: true,
    dateFormat: 'mm/dd/yyyy'
  };

  ngOnInit(): void {
    this.vm$ = this.loadTourManagementDetailsData$();
  }

  private loadTourManagementDetailsData$(): Observable<ITourManagementViewData> {
    return this.tourManagementService.getDetailsMockDate().pipe(
      map((v: ITourDetail) => {
        const ret: ITourManagementViewData = {
          selectionDisallowed: true,
          tourDetails: v
        };
        return ret;
      }
    ));
  }

  refreshPage() {
    this.vm$ = this.loadTourManagementDetailsData$();
    this.authService.userInRole;
  }

  cancel() {
    this.location.back();
  }
}


/**
* 
*/
interface ITourManagementViewData extends IPageViewModel {
  selectionDisallowed: boolean;
  tourDetails: ITourDetail;
}
